"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTopicBroadcastResponseDto = instanceOfTopicBroadcastResponseDto;
exports.TopicBroadcastResponseDtoFromJSON = TopicBroadcastResponseDtoFromJSON;
exports.TopicBroadcastResponseDtoFromJSONTyped = TopicBroadcastResponseDtoFromJSONTyped;
exports.TopicBroadcastResponseDtoToJSON = TopicBroadcastResponseDtoToJSON;
exports.TopicBroadcastResponseDtoToJSONTyped = TopicBroadcastResponseDtoToJSONTyped;
/**
 * Check if a given object implements the TopicBroadcastResponseDto interface.
 */
function instanceOfTopicBroadcastResponseDto(value) {
    if (!('broadcastId' in value) || value['broadcastId'] === undefined)
        return false;
    return true;
}
function TopicBroadcastResponseDtoFromJSON(json) {
    return TopicBroadcastResponseDtoFromJSONTyped(json, false);
}
function TopicBroadcastResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'broadcastId': json['broadcastId'],
    };
}
function TopicBroadcastResponseDtoToJSON(json) {
    return TopicBroadcastResponseDtoToJSONTyped(json, false);
}
function TopicBroadcastResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'broadcastId': value['broadcastId'],
    };
}
